import { Version } from '@cipafacil/version/version';

const __CIPAFACIL_VERSION__ = '2.0.0';
export const CIPAFACIL_VERSION = new Version(__CIPAFACIL_VERSION__).full;
